/**
 * Created by r4zi4l on 21.12.2021
 */

const RudolfGuideOptions = {
    name: "RudolfGuideWindow",
    title: "RudolfGuideWindow.title",
    description: "RudolfGuideWindow.description",

    getGuideBundle: function () {
        return cleverapps.skins.getSlot("rudolfGuideBundle");
    },

    stagesContent: function () {
        const styles = cleverapps.styles.RudolfGuideWindow;

        const stage1 = this.initStage(styles.firstStage, (styles, container) => {
            this.addSprite(container, this.bundle.frames.gifts, styles.gifts);
        });

        const stage2 = this.initStage(styles.secondStage, (styles, container) => {
            this.addSprite(container, this.bundle.frames.rudolf, styles.rudolf);
        });

        const stage3 = this.initStage(styles.thirdStage, (styles, container) => {
            this.addSprite(container, this.bundle.frames.prizes_heap, styles.heap);
        });

        return [stage1, stage2, stage3];
    }
};

cleverapps.styles.RudolfGuideWindow = {
    description: {
        width: 800,
        height: 0
    },

    firstStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        gifts: {
            x: 0,
            y: -30
        }
    },

    secondStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        rudolf: {
            x: 0,
            y: 0
        }
    },

    thirdStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        heap: {
            x: 0,
            y: 0
        }
    }
};
